define('modules/lp_info/views/change_url_popup',['require','exports','module','common/views/modal_view','env','i18n','backbone','ldsh!../templates/change_url_popup'],function (require, exports, module) {
  'use strict';

  var ModalView = require('common/views/modal_view'),
    config = require('env'),
    i18n = require('i18n'),
    Backbone = require('backbone');

  module.exports = ModalView.extend(
    {
      initialize: function (options) {
        this.viewModel = new Backbone.Model({
          domains: options.domains,
          defaultDomain: config.defaultDomain,
        });
        this.listenTo(options.domains, 'sync', this.render);
      },

      template: require('ldsh!../templates/change_url_popup'),

      className: 'ed-overlay popUp-url-publicacion',

      triggers: {
        'click .js-ok': 'ok',
        'click .js-cancel': 'cancel',
        'click .js-add-domain': 'addDomain',
      },

      events: {
        'change .js-domain-selector': 'onDomainChange',
        'keypress .js-uri': 'checkEnter',
      },

      onRender: function () {
        this.$el.i18n();
        this.onDomainChange({ currentTarget: '.js-domain-selector' });
      },

      onDomainChange: function () {
        var uri = this.model.get('uri'),
          fullUrl = this.model.get('full_url');

        if (fullUrl.match(/\/\w+$/) == uri) {
          this.$('.js-uri').val(uri.replace(/\//, ''));
        } else {
          this.$('.js-uri').val(this.getUri());
        }
      },

      getData: function () {
        var domains_id = this.$('.js-domain-selector').val(),
          uri = this.$('.js-uri').val().trim(),
          strict_transport_security = this.$('#strict_transport_security').is(':checked');

        if (uri.length > 0 && uri.indexOf('/') !== 0) {
          uri = '/' + uri;
        }
        return {
          domains_id: domains_id === 'default' ? null : domains_id,
          domains_uri: domains_id === 'default' && uri === '/' ? '' : uri,
          strict_transport_security: strict_transport_security,
        };
      },

      getUri: function () {
        var fullUrl = this.model.get('full_url'),
          uri = fullUrl.match(/\.\w+\/(.+)$/);
        return uri ? uri[1] : '';
      },

      helpers: function () {
        var self = this,
          fullUrl = this.model.get('full_url'),
          strictTransportSecurity = this.model.get('strict_transport_security'),
          templateData;

        if (fullUrl.indexOf('//') === 0) {
          fullUrl = 'https:' + fullUrl;
        }

        templateData = {
          path: function () {
            return self.getUri();
          },
          selected: function (domain) {
            if (self.model.get('domains_id') === undefined && domain === config.defaultDomain) {
              return 'selected';
            } else if (domain.get && self.model.get('domains_id') === domain.get('id')) {
              return 'selected';
            } else {
              return '';
            }
          },
          fullUrl: fullUrl,
          strictTransportSecurity: strictTransportSecurity,
          badDomainText: i18n.t('landingPage.dialog.url.badDomainText'),
        };

        return templateData;
      },

      checkEnter: function (e) {
        if (e.which == 13) {
          this.trigger('enterClicked');
        }
      },
    },
    {
      show: function (page, domains) {
        var popup = new module.exports({ domains: domains, model: page }),
          defer = $.Deferred();
        popup.on('ok enterClicked', function () {
          defer.resolve(popup.getData());
        });
        popup.on('cancel hide addDomain', _.bind(defer.reject, defer));
        popup.on('cancel addDomain', popup.hide, popup);
        popup.on('addDomain', function () {
          Backbone.history.navigate('/domains', { trigger: true });
        });
        return defer.promise();
      },
    }
  );
});

